import { Component } from "react";
import { initGA, logPageView } from '../utils/analytics'

class Layout extends Component {
    componentDidMount () {
        if (!window.GA_INITIALIZED) {
            initGA()
            window.GA_INITIALIZED = true
        }
        logPageView()
    }
    
    render() {
        return (
            <layout>
                {this.props.children}

                <script src="/static/js/jquery-3.4.1.slim.min.js"></script>
                <script src="/static/js/popper-1.14.7.min.js"></script>
                <script src="/static/bootstrap/js/bootstrap.min.js"></script>
                <script src="/static/js/common.min.js"></script>
            </layout>
        );
    }
}

export default Layout;